import React from "react";

export interface OriginsListItemContentConverterProps {
    children?: React.ReactNodeArray;
    className?: string;
    datalabel?: string;
}

const OriginsListItemContentConverter = (
    props: OriginsListItemContentConverterProps
) => {
    // There are times where props.children is undefined
    if (props.children == null) {
        return null;
    }

    return (
        <div className="c-origins-list__item__content">{props.children}</div>
    );
};

export default OriginsListItemContentConverter;
